import { Injectable } from '@angular/core';
import { DataCollectionCreate } from '../models/data-collection-create.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PanelVehicleCommunicationService {
  private dataCollectionBehaviorSubject =
    new BehaviorSubject<DataCollectionCreate>({
      variant: 'undefined',
      nameVariant: '',
      id: { idOperation: 0, idGroup: 0 },
      data: [],
    });
  private dataCollectionCreate$ =
    this.dataCollectionBehaviorSubject.asObservable();

  public emitEventDataCollectionCreate(
    dataCollectionCreate: DataCollectionCreate
  ) {
    this.dataCollectionBehaviorSubject.next(dataCollectionCreate);
  }

  public getEventDataCollectionCreate() {
    return this.dataCollectionCreate$;
  }
}
